import React from 'react';

import { useTheme } from '@mui/material';
import type { AlineAvatarSize } from 'src/components';
import { AlineAvatar, alineAvatarSizes, CurrentUserOrgAvatar } from 'src/components';
import type { AccountSubset } from 'src/types';

interface AccountAvatarProps {
  account: AccountSubset;
  size?: AlineAvatarSize;
}

export function AccountAvatar(props: AccountAvatarProps): JSX.Element {
  const theme = useTheme();
  const { account, size = 'lg' } = props;
  const sizeConfig = alineAvatarSizes[size];
  const backgroundColor = account.avatarColor ?? theme.appColors.accent4;

  switch (account.__typename) {
    case 'User':
      return <AlineAvatar avatarInfo={account} styles={{ backgroundColor, size }} />;
    case 'Org':
      return <CurrentUserOrgAvatar height={sizeConfig.size} width={sizeConfig.size} />;
  }
}
